import React from "react"
import i18n from "../i18n"
import config from "../config"

const SettingsContext = React.createContext()

function useSettings() {
  const context = React.useContext(SettingsContext)
  if (!context) {
    throw new Error(`useSettings must be used within a SettingsProvider`)
  }

  const [settings, setSettings] = context.settings

  return { settings, setSettings }
}

function SettingsProvider(props) {
  const [value, setValue] = React.useState({
    language: (() => {
      const browserLang =
        typeof navigator !== "undefined"
          ? (navigator.language || "").slice(0, 2).toLowerCase()
          : null
      return (config?.languages || []).includes(browserLang)
        ? browserLang
        : config?.default_language || "de"
    })(),
  })

  React.useEffect(() => {
    i18n.changeLanguage(value.language)
  }, [value.language])

  const settings = React.useMemo(() => [value, setValue], [value])

  return <SettingsContext.Provider value={{ settings }} {...props} />
}

export { SettingsProvider, useSettings }
